import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {AnyChappsListLoadResponse, ChappListLoadResponse} from "@npm.chapps.com/chapps.common.angular.library";
import { Observable, of, Subject } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { ApiRouteConfig } from "../../config/api.route.config";
import { InterventionTeamSummary } from "../buildings/model/Intervention-team-summary";
import { Action } from "../common/model/action";
import { ExecutorDetails } from "./models/executor-details.model";
import { Executor } from "./models/executor.model";

@Injectable()
export class ExecutorsService{

    public added$: Subject<any> = new Subject<any>();
    public updated$: Subject<any> = new Subject<any>();

    constructor(private httpClient: HttpClient, private config: ApiRouteConfig){

    }

    public getExecutors(buildingGuids: string[], pageNumber: number = 1, pageSize: number = 10){

        return this.httpClient.post(this.config.INTERVENTION_TEAMS_SEARCH, {
          pageNumber, pageSize, buildingGuids
        })
    }

    public getExecutorDetails(guid: string): Observable<ExecutorDetails>{
        return this.httpClient.get<ExecutorDetails>(this.config.getRouteWithInjectedParams(this.config.INTERVENTION_TEAM_DETAIL, [guid]));
    }

    public addExecutor(executor: Executor){
        return this.httpClient.post<Executor>(this.config.INTERVENTION_TEAMS, executor)
            .pipe(catchError(() => {
                return of(null);
            }))
    }

    public updateExecutor(executor: Executor){
        return this.httpClient.put<Executor>(this.config.INTERVENTION_TEAMS, executor)
            .pipe(catchError(() => {
                return of(null);
            }))
    }

    public deleteExecutor(interventionTeamId: string){
        return this.httpClient.delete(this.config.getRouteWithInjectedParams(this.config.INTERVENTION_TEAM_DETAIL, [interventionTeamId]))
            .pipe(
                tap(() => this.updated$.next(null)),
                catchError(error => {
                    return of(null);
                })
            )
    }

    public getExecutorJobs(interventionTeamId: string){
        return this.httpClient.get<Action[]>(this.config.getRouteWithInjectedParams(this.config.INTERVENTION_TEAMS_ACTION, [interventionTeamId]));

    }

    public getAllFor(buildingId: string) {

      return this.httpClient.post<ChappListLoadResponse<Executor>>(this.config.INTERVENTION_TEAMS_SEARCH, {
        buildingGuids: [buildingId]
      });
    }

    public getAll(): Observable<ChappListLoadResponse<Executor>> {
        return this.httpClient.get<ChappListLoadResponse<Executor>>(this.config.INTERVENTION_TEAMS_ALL);
      }
}
